module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-fill-f280acbd.svg";